<template>
  <div class="marginBT grid">
    <div class="lg:col-2 sm:col-12" />
    <div class="lg:col-8 sm:col-12">
      <div class="marginLR center">
        <h2 class="titles">{{ $t("consultaFichero.titulo2") }}</h2>
        <p class="subtitles">{{ $t("consultaFichero.subtitulo2") }}</p>
      </div>
      <div class="whitePanel">
        <Success v-if="success && success.length > 0" :success="this.success" />
        <Errors v-show="this.errors.length > 0" :errors="this.errors" />
        <div class="lg:col-12 sm:col-12" v-if="!usuarioGrandesCuentas">
          <div>
            <h4>{{ $t("consultaFichero.textos.titularConsulta") }}</h4>
            <div class="p-field-radiobutton">
              <RadioButton
                id="autorization-1"
                name="autorization-1"
                :value="this.tipoSolicitud.propia"
                @click="onSelectActuoEnPropioNombre"
                v-model="datosCliente.tipo"
              />

              <label for="autorization-1">{{
                $t("consultaFichero.textos.actuoPropioNombre")
              }}</label>
            </div>
          </div>
          <div class="p-field-radiobutton">
            <RadioButton
              id="autorization-2"
              name="autorization-2"
              :value="tipoSolicitud.terceros"
              v-model="datosCliente.tipo"
            />
            <label for="autorization-2">{{
              $t("consultaFichero.textos.actuoRepresentando")
            }}</label>
          </div>
        </div>

        <div v-if="!usuarioGrandesCuentas">
          <div
            class="col-12 md:col-6"
            v-show="datosCliente.tipo === tipoSolicitud.terceros"
          >
            <InputText
              :class="`input ${validation.name === false && 'p-invalid'}`"
              id="name"
              type="text"
              v-model="datosCliente.nombre"
              :placeholder="
                $t('consultaFichero.placeholders.representacionNombre')
              "
              @blur="validateInput"
            />
            <small v-if="validation.name === false" class="p-invalid">{{
              $t("consultaFichero.messages.error.campoIncorrecto")
            }}</small>
          </div>
          <div
            class="col-12 md:col-6"
            v-show="datosCliente.tipo === tipoSolicitud.terceros"
          >
            <InputText
              :class="`input ${validation.idLegal === false && 'p-invalid'}`"
              id="idLegal"
              type="text"
              v-model="datosCliente.idLegal"
              :placeholder="
                $t('consultaFichero.placeholders.representacionNif')
              "
              @blur="validateInput"
            />
            <small v-if="validation.idLegal === false" class="p-invalid">{{
              $t("consultaFichero.messages.error.campoIncorrecto")
            }}</small>
          </div>
        </div>
        <h4>{{ $t("consultaFichero.textos.nifConsultar") }}</h4>

        <InputConsulta
          tipo="consulta"
          v-bind:entidad="datosDeudor"
          :tipoEntidad="USUARIO_TIPO_DEUDOR_ENTIDAD"
          :disabled="false"
          v-on:show-error="setError"
          @esCif="validarCif"
        />
        <div v-if="usuarioGrandesCuentas">
          <h4>{{ $t("consultaFichero.grandesCuentas.consultor") }}</h4>
          <ListadoCarterasUsuario
            :filters="carteraUsuarioFilters"
            @cartera-usuario-click="onCarteraUsuarioClick"
            :showUsuarioColumns="true"
          />
          <div v-show="usuarioCarteraSelected" class="grid col-12">
            <div class="col-12 md:col-6 field">
              <label for="nombre"
                ><b>{{
                  $t("consultaFichero.grandesCuentas.nombreAcreedor")
                }}</b></label
              >
              <InputText
                class="input"
                type="text"
                v-model="acreedorGrandesCuentas.nombre"
                :disabled="
                  usuarioCarteraSelected
                    ? usuarioCarteraSelected.acreedorObligatorio
                    : false
                "
              />
            </div>
            <div class="col-12 md:col-6 field">
              <label
                ><b>{{
                  $t("consultaFichero.grandesCuentas.nifNieCifAcreedor")
                }}</b></label
              >
              <InputText
                class="input"
                type="text"
                v-model="acreedorGrandesCuentas.idLegal"
                :disabled="
                  usuarioCarteraSelected
                    ? usuarioCarteraSelected.acreedorObligatorio
                    : false
                "
              />
            </div>
          </div>
          <h4>{{ $t("consultaFichero.grandesCuentas.seleccioneProducto") }}</h4>
          <ListadoProductos
            :idLegalCliente="
              usuarioActual ? usuarioActual.clienteIdLegal : null
            "
            :tituloHeader="$t('common.titulos.seleccione')"
            @producto-click="onProductoClick"
            :selectedProductoValue="selectedProducto"
            :tipo="'consulta'"
          />
        </div>

        <div class="marginBottom">
          <div v-if="!usuarioGrandesCuentas">
            <h3>{{ $t("consultaFichero.textos.relacion") }}</h3>
            <div class="grid">
              <div class="col-12">
                <div class="p-field-radiobutton">
                  <RadioButton
                    id="opcion-1"
                    name="opcion-1"
                    :value="tiposContrato.vigente"
                    v-model="opcion"
                  />
                  <label for="opcion-1">{{
                    $t("consultaFichero.textos.opcion1")
                  }}</label>
                  <div>
                    <small
                      class="smallBlueText"
                      v-if="this.draft && this.draft.pagado"
                    >
                      {{ $t("consultaFichero.textos.opcion1Subtexto") }}
                    </small>
                  </div>
                </div>
                <div class="p-field-radiobutton">
                  <RadioButton
                    id="opcion-2"
                    name="opcion-2"
                    :value="tiposContrato.aplazamiento"
                    v-model="opcion"
                  />
                  <label for="opcion-2">{{
                    $t("consultaFichero.textos.opcion2")
                  }}</label>
                  <div>
                    <small
                      class="smallBlueText"
                      v-if="this.draft && this.draft.pagado"
                    >
                      {{ $t("consultaFichero.textos.opcion2Subtexto") }}
                    </small>
                  </div>
                </div>
                <div class="p-field-radiobutton">
                  <RadioButton
                    id="opcion-3"
                    name="opcion-3"
                    :value="tiposContrato.periodico"
                    v-model="opcion"
                  />
                  <label for="opcion-3">
                    {{ $t("consultaFichero.textos.opcion3") }}</label
                  >
                  <div>
                    <small
                      class="smallBlueText"
                      v-if="this.draft && this.draft.pagado"
                    >
                      {{ $t("consultaFichero.textos.opcion3Subtexto") }}
                    </small>
                  </div>
                </div>
              </div>

              <div
                class="search-show col-12"
                v-if="this.draft && this.draft.pagado"
              >
                <div class="container-white">
                  <div class="grid">
                    <div class="col-1 text-blue">
                      <i class="pi pi-info-circle"></i>
                    </div>
                    <div class="col-11 marginNegative">
                      <div class="text-blue bold">
                        {{ $t("consultaFichero.textos.info1") }}
                      </div>
                      <p class="text-blue bold no-mb-xs">
                        {{ $t("consultaFichero.textos.info2") }}
                      </p>
                      <p class="no-mb-xs">
                        {{ $t("consultaFichero.textos.info3") }}
                      </p>
                      <p></p>
                      <div class="mt-x1-2-xs">
                        <i class="pi pi-download text-blue"></i>
                        <a
                          class="text-blue link"
                          download="Anexo I ICIRED.docx"
                          href="/assets/documentos/Anexo_I_ICIRED.docx"
                          >{{ $t("consultaFichero.textos.info4") }}</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12" v-if="this.draft && this.draft.pagado">
                <div class="bluePanel resetMarginTop">
                  <h3
                    v-html="$t('consultaFichero.textos.opcion3Pregunta2')"
                  ></h3>
                  <div>
                    <p>
                      <b>{{ $t("consultaFichero.textos.opcion4Info1") }}</b>
                    </p>
                    <ul>
                      <li>
                        {{ $t("consultaFichero.textos.opcion4Info2") }}
                      </li>
                      <li>
                        {{ $t("consultaFichero.textos.opcion4Info3") }}
                        <ul>
                          <li>
                            {{ $t("consultaFichero.textos.opcion4Info3_1") }}
                          </li>
                          <li>
                            {{ $t("consultaFichero.textos.opcion4Info3_2") }}
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <p>
                      <b>{{ $t("consultaFichero.textos.opcion5Info1") }}</b>
                    </p>
                    <ul>
                      <li>
                        {{ $t("consultaFichero.textos.opcion5Info3_1") }}
                      </li>
                      <li>
                        {{ $t("consultaFichero.textos.opcion5Info3_2") }}
                        <ul>
                          <li>
                            {{ $t("consultaFichero.textos.opcion4Info3_1") }}
                          </li>
                          <li>
                            {{ $t("consultaFichero.textos.opcion4Info3_2") }}
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                  <div class="col-12 md:col-4">
                    <div class="attachFile withBorderWhite">
                      <input
                        @change="onFileChange"
                        ref="fileInput"
                        type="file"
                        id="file"
                        class="file"
                        multiple
                      />
                      <label for="file">
                        <i class="pi pi-paperclip iconSize fileIcon" />
                        {{ $t("common.buttons.adjuntarArchivos") }}
                      </label>
                    </div>
                    <div class="fileList">
                      <div
                        v-for="(file, index) in files"
                        :key="'file' + file.name + index"
                      >
                        <span
                          class="cursorPointer"
                          @click="
                            [removeArrayElement(files, file), resetInputFile()]
                          "
                        >
                          <i class="pi pi-times iconSize buttonIcon" />
                        </span>
                        <span class="fileText">{{ file.name }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 buttonContainer">
            <Button
              @click="realizarBusqueda()"
              :label="
                (this.draft && this.draft.pagado) ||
                this.bonoAplicable ||
                this.$store.state.esGranCliente
                  ? this.$t('consultaFichero.label.enviar')
                  : this.$t('consultaFichero.label.pagar')
              "
              class="bigBlueButton"
              :disabled="this.errors.length > 0 || disabledRealizarBusqueda"
              style="margin-top: 2em"
              iconPos="right"
            />
          </div>

          <div v-if="!usuarioGrandesCuentas" class="col-12 search-show">
            <div class="container-white">
              <div class="grid">
                <div class="col-1 text-blue">
                  <i class="pi pi-info-circle"></i>
                </div>
                <div class="col-11 marginNegative">
                  {{ $t("consultaFichero.textos.infoSolicitud") }}
                </div>
              </div>
              <div class="grid marginTop">
                <div class="col-1"></div>
                <div class="col-11 marginNegative">
                  <Button
                    @click="goToDashboardtView('my-searches')"
                    :label="$t('consultaFichero.button.irMisBusquedas')"
                    class="p-button-rounded p-button-outlined"
                    iconPos="right"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="lg:col-2 sm:col-12" />

    <Dialog
      :visible.sync="displayModalFaltaInformacion"
      :modal="true"
      :contentStyle="{ overflow: 'visible' }"
      :closable="false"
    >
      <template #header>
        <span>
          {{ $t("datos.header.faltaInformacion") }}
        </span>
      </template>
      <div class="grid paddingLR">
        <div class="col-12">
          {{ $t("datos.textos.faltaInformacion") }}
        </div>
      </div>
      <template #footer>
        <div class="center">
          <Button
            :label="$t('common.buttons.accept')"
            icon="pi pi-check"
            @click="redirigirAlProfile()"
            autofocus
          />
        </div>
      </template>
    </Dialog>
    <Dialog
      :header="$t('consultaFichero.label.borradorEncontrado')"
      :modal="true"
      :visible.sync="displayDraftWarningModal"
      :contentStyle="{ overflow: 'visible' }"
      :style="{ width: '65vw' }"
      class="modal"
    >
      <p>{{ $t("consultaFichero.textos.borradorEncontrado") }}</p>
      <template #footer>
        <Button
          @click.prevent="$router.push('/dashboard/my-searches/borradores')"
          :label="$t('consultaFichero.button.continuarConBorrador')"
          class="p-button-primary"
        />
        <Button
          @click.prevent="displayDraftWarningModal = false"
          :label="$t('consultaFichero.button.crearNuevaConsulta')"
          class="p-button-secondary"
          icon="pi pi-times"
          iconPos="left"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import InputConsulta from "../Utils/InputConsulta";
import Errors from "@/components/utilidades/Errors.vue";
import ListadoCarterasUsuario from "@/components/portal-gran-cliente/Carteras/ListadoCarterasUsuario";
import { GET_PRODUCTOS_BY_IDLEGAL_CLIENTE } from "@/graphQLQueries/ProductoQueries";
import { ALTA_SOLICITUD_REQUEST_INPUT } from "@/graphQLQueries/ConsultasQueries";
import { TIPOS_USUARIOS , PLATAFORMA, TIPOS_SERVICIO, TIPOS_BONO} from "@/resources/constants";
import { GET_USUARIO_BY_UUID } from "@/graphQLQueries/UsuarioQueries";
import {
  MAKE_PAYMENT_CONSULTAS,
  UPDATE_TRANSACTION_STATUS,
} from "@/graphQLQueries/PaymentQueries";
import {
  QUERY_BORRADORES,
  QUERY_BORRADOR,
} from "@/graphQLQueries/BorradoresQueries";
import validations from "@/utils/validations.js";
import MessagesMixin from "@/utils/messages";
import DatesMixin from "@/utils/dates";
import FilesMixin from "@/utils/files";
import DownloadsMixin from "@/utils/downloads";
import RoutesMixin from "@/utils/routes";
import StringsMixin from "@/utils/strings";
import Success from "@/components/utilidades/Success.vue";
import ListadoProductos from "@/components/portal-gran-cliente/productos/ListadoProductos.vue";
export default {
  name: "ConsultarImpago",
  mixins: [
    FilesMixin,
    MessagesMixin,
    RoutesMixin,
    DownloadsMixin,
    DatesMixin,
    StringsMixin,
  ],
  components: {
    Success,
    InputConsulta,
    Errors: Errors,
    ListadoCarterasUsuario,
    ListadoProductos,
  },
  created() {
    this.USUARIO_TIPO_DEUDOR_ENTIDAD =
      TIPOS_USUARIOS.USUARIO_TIPO_DEUDOR_ENTIDAD;
    this.setUsuarioGrandesCuentas();
  },
  data() {
    return {
      disabledRealizarBusqueda: false,
      errors: [],
      success: [],
      opcion: "",
      esCif: true,
      displayModalFaltaInformacion: false,
      displayDraftWarningModal: false,
      draft: null,
      idSegmento: null,
      datosCliente: {
        tipo: undefined,
        origen: "WEB",
        idLegal: "",
      },
      datosDeudor: {
        nombre: "",
        apellidos: "",
        idLegal: "",
        telefono: "",
        email: "",
        codigoPostal: "",
        direccion: "",
        localidad: "",
        pais: "",
        provincia: "",
        tipoVia: "",
      },
      files: [],
      validation: {
        name: "",
        lastName: "",
        idLegal: "",
        telephone: "",
      },
      usuarioGrandesCuentas: null,
      tipoSolicitud: {
        terceros: "TERCEROS",
        propia: "PROPIA",
      },
      tiposContrato: {
        vigente: "CONTRATO_VIGENTE",
        aplazamiento: "CONTRATO_APLAZAMIENTO",
        periodico: "CONTRATO_PERIODICO",
      },
      bonoAplicable: false,
      usuarioCarteraSelected: null,
      usuarioActual: null,
      acreedorGrandesCuentas: {
        nombre: null,
        idLegal: null,
      },
      selectedProducto: null,
    };
  },
  mounted() {
    this.loadUserData();
    this.loadDraft();
    this.checkPreviousDrafts();
  },
  methods: {
    setUsuarioGrandesCuentas() {
      this.usuarioGrandesCuentas = this.$store.state.cartera;
      this.$store.watch(
        () => {
          return this.$store.state.cartera;
        },
        (newValue) => {
          this.usuarioGrandesCuentas = newValue;
        }
      );
    },
    toJson(obj) {
      return JSON.stringify(obj);
    },
    onCarteraUsuarioClick(carteraUsuario) {
      this.usuarioCarteraSelected = carteraUsuario;
      this.acreedorGrandesCuentas = {
        nombre: null,
        idLegal: null,
      };

      if (
        this.usuarioCarteraSelected &&
        this.usuarioCarteraSelected.acreedor &&
        (this.usuarioCarteraSelected.acreedorPorDefecto ||
          this.usuarioCarteraSelected.acreedorObligatorio)
      ) {
        this.acreedorGrandesCuentas.nombre = this.getFullName(
          this.usuarioCarteraSelected.acreedor.nombre,
          this.usuarioCarteraSelected.acreedor.apellidos,
          this.usuarioCarteraSelected.acreedor.razonSocial
        );
        this.acreedorGrandesCuentas.idLegal =
          this.usuarioCarteraSelected.acreedor.idLegal;
      }
    },
    onFileChange(e) {
      const seen = new Set();
      let arrayFiles = this.files.concat(Array.from(e.target.files));
      const filteredArr = arrayFiles.filter((el) => {
        const duplicate = seen.has(el.name);
        seen.add(el.name);
        return !duplicate;
      });
      this.files = filteredArr;
    },
    removeArrayElement(list, value) {
      let idx = list.indexOf(value);

      if (idx !== -1) {
        list.splice(idx, 1);
      }
    },
    resetInputFile() {
      this.$refs.fileInput.value = null;
    },
    generarAltaSolicitud(base64Files) {
      if (this.usuarioGrandesCuentas) {
        this.idSegmento = this.usuarioCarteraSelected.segmento ? this.usuarioCarteraSelected.segmento.id : null;
        this.opcion = this.tiposContrato.vigente;
        this.datosCliente.idLegal = null;
        this.datosCliente.nombre = null;
        if (this.usuarioCarteraSelected) {
          this.datosCliente.idLegal = this.acreedorGrandesCuentas.idLegal;
            //this.usuarioCarteraSelected.acreedor.idLegal;
          this.datosCliente.nombre = this.acreedorGrandesCuentas.nombre; 
            //this.usuarioCarteraSelected.acreedor.nombre
            //? this.usuarioCarteraSelected.usuarioCliente.nombre
            //: this.usuarioCarteraSelected.usuarioCliente.razonSocial;
        }
        this.datosCliente.tipo =
          this.datosCliente &&
          this.datosCliente.idLegal == this.$store.state.idLegal
            ? this.tipoSolicitud.propia
            : this.tipoSolicitud.terceros;
      }
      const isPropio = this.datosCliente.tipo == this.tipoSolicitud.propia;

      return {
        ficheros: base64Files,
        idLegalDeudor: this.datosDeudor.idLegal,
        idLegalRepresentado: isPropio ? "" : this.datosCliente.idLegal,
        justificacion: this.opcion,
        origen: this.datosCliente.origen,
        plataforma: "icired",
        razonSocialRepresentado: this.datosCliente.nombre,
        representacionPropia: isPropio,
        uuidSolicitante: this.$store.state.profile.uuid,
        idBorrador: this.draft ? this.draft.id : null,
        idSegmento: this.idSegmento,
      };
    },
    validarCif(event) {
      this.esCif = event;
    },
    realizarBusqueda() {
      if (this.validateForm()) {
        if (this.usuarioGrandesCuentas) {
          this.disabledRealizarBusqueda=true;
          if (this.comprobarBonoProducto(this.selectedProducto)) {
            this.solicitudBusqueda();
          }
        } else {
          if (this.draft && this.draft.pagado) {
            this.solicitudBusqueda();
          } else {
            this.pagarSolicitudBusqueda();
          }
        }
      }
    },
    async pagarSolicitudBusqueda() {
      let altaSolicitudRequest = null;
      let base64Files = null;
      if (this.files == null){
        base64Files = await this.convertFiles(this.files);
      }
      const altaSolicitud = this.generarAltaSolicitud(base64Files);
      let bonoAplicable = null;
      let idCombinado = null;
      let idPromocion = null;
      if (this.selectedProducto){
        bonoAplicable = this.selectedProducto.promociones[0];
        idCombinado = TIPOS_BONO.COMBINADO === bonoAplicable.tipo ? bonoAplicable.id : null;
        idPromocion = TIPOS_BONO.PROMOCION === bonoAplicable.tipo ? bonoAplicable.id : null;
      }

      altaSolicitudRequest = this.usuarioGrandesCuentas
        ? {
            ficheros: null,
            idLegalDeudor: this.datosDeudor.idLegal,
            idLegalRepresentado: this.acreedorGrandesCuentas.idLegal,
            justificacion: altaSolicitud.justificacion,
            origen: altaSolicitud.origen,
            plataforma: altaSolicitud.plataforma,
            razonSocialRepresentado: this.acreedorGrandesCuentas.nombre,
            representacionPropia:
              this.acreedorGrandesCuentas.idLegal ===
              this.usuarioActual.idLegal,
            uuidSolicitante: altaSolicitud.uuidSolicitante,
            tipo: this.selectedProducto.codigoProducto,
            idPromocionUso: idPromocion,
            idCombinadoUso: idCombinado,
          }
        : {
            ficheros: altaSolicitud.ficheros,
            idLegalDeudor: altaSolicitud.idLegalDeudor,
            idLegalRepresentado: altaSolicitud.idLegalRepresentado,
            justificacion: altaSolicitud.justificacion,
            origen: altaSolicitud.origen,
            plataforma: altaSolicitud.plataforma,
            razonSocialRepresentado: altaSolicitud.razonSocialRepresentado,
            representacionPropia: altaSolicitud.representacionPropia,
            uuidSolicitante: altaSolicitud.uuidSolicitante,
            tipo: this.$route.params.codType,
          };
      try {
        const response = await this.$apollo
          .mutate({
            mutation: MAKE_PAYMENT_CONSULTAS,
            variables: {
              input: altaSolicitudRequest,
              plataforma: PLATAFORMA,
              urlReturn:
                window.location.origin +
                `/consultaFichero/${altaSolicitudRequest.tipo}/:draftId`,
            },
          }).catch((error) => {
            this.errors = [];
            error.graphQLErrors.forEach((error) => {
              this.errors.push(
                this.$i18n.t("consultaFichero.errores." + error.message)
              );
            });
            window.scrollTo(0, 0);
          });

        if (response && response.data && response.data.makeWorldlineRedirectPaymentConsulta.paymentResponseModel.bono) {
          this.draft = response.data.makeWorldlineRedirectPaymentConsulta.borradorResponse;
          this.draft.pagado = true;
          this.checkBonoAplicables(this.usuarioActual.clienteIdLegal);
          this.solicitudBusqueda();
        } else {
          location.replace(response.data.makeWorldlineRedirectPaymentConsulta.paymentResponseModel.datos.url);
        }
      } catch (e) {
        throw Error(e);
      }
    },
    async solicitudBusqueda() {
      let altaSolicitudRequest = null;
      let base64Files = null;
      if (this.files == null){
        base64Files = await this.convertFiles(this.files);
      }
      const altaSolicitud = this.generarAltaSolicitud(base64Files);
      let bonoAplicable = null;
      let idCombinado = null;
      let idPromocion = null;
      if (this.selectedProducto){
        bonoAplicable = this.selectedProducto.promociones[0];
        idCombinado = TIPOS_BONO.COMBINADO === bonoAplicable.tipo ? bonoAplicable.id : null;
        idPromocion = TIPOS_BONO.PROMOCION === bonoAplicable.tipo ? bonoAplicable.id : null;
      }
      altaSolicitudRequest = this.usuarioGrandesCuentas
        ? {
            ficheros: null,
            idBorrador: this.draft ? this.draft.id : null,
            idLegalDeudor: this.datosDeudor.idLegal,
            idLegalRepresentado: this.acreedorGrandesCuentas.idLegal,
            justificacion: altaSolicitud.justificacion,
            origen: altaSolicitud.origen,
            plataforma: altaSolicitud.plataforma,
            razonSocialRepresentado: this.acreedorGrandesCuentas.nombre,
            representacionPropia:
              this.acreedorGrandesCuentas.idLegal ===
              this.usuarioActual.idLegal,
            uuidSolicitante: altaSolicitud.uuidSolicitante,
            tipo: this.selectedProducto.codigoProducto,
            idSegmento: altaSolicitud.idSegmento,
            idPromocionUso: idPromocion,
            idCombinadoUso: idCombinado,
          }
        : {
            ficheros: altaSolicitud.ficheros,
            idBorrador: this.draft ? this.draft.id : null,
            idLegalDeudor: altaSolicitud.idLegalDeudor,
            idLegalRepresentado: altaSolicitud.idLegalRepresentado,
            justificacion: altaSolicitud.justificacion,
            origen: altaSolicitud.origen,
            plataforma: altaSolicitud.plataforma,
            razonSocialRepresentado: altaSolicitud.razonSocialRepresentado,
            representacionPropia: altaSolicitud.representacionPropia,
            uuidSolicitante: altaSolicitud.uuidSolicitante,
            tipo: this.$route.params.codType,
            idSegmento: altaSolicitud.idSegmento,
          };
      this.$apollo
        .mutate({
          mutation: ALTA_SOLICITUD_REQUEST_INPUT,
          variables: {
            input: altaSolicitudRequest,
            idioma: this.$i18n.locale,
          },
        })
        .then((data) => {
          this.errors = [];
          if (this.usuarioGrandesCuentas) {
            const solicitudResponse = data.data.altaSolicitud;
            this.disabledRealizarBusqueda=false;
            this.goToFichaConsulta(
              data.data.altaSolicitud.token,
              this.toJson(solicitudResponse.deudasSolicitudResponse)
            );
            return;
          }

          this.goToConsultaRealizada(data.data.altaSolicitud.token);
        })
        .catch((error) => {
          this.errors = [];
          error.graphQLErrors.forEach((error) => {
            this.errors.push(
              this.$i18n.t("consultaFichero.errores." + error.message)
            );
          });
          window.scrollTo(0, 0);
        });
    },
    validateInput(e) {
      switch (e.target.id) {
        case "name":
          return e.target.value && typeof e.target.value === "string"
            ? (this.validation.name = true)
            : (this.validation.name = false);
        case "idLegal":
          return e.target.value &&
            /([a-z]|[A-Z]|[0-9])[0-9]{7}([a-z]|[A-Z]|[0-9])/g.test(
              e.target.value
            )
            ? (this.validation.idLegal = true)
            : (this.validation.idLegal = false);
        default:
          console.error("ID error");
      }
    },
    async loadDraft() {
      const draftId = this.$route.params.draftId;
      if (draftId !== undefined) {
        try {
          const response = await this.$apollo.query({
            query: QUERY_BORRADOR,
            variables: {
              id: draftId,
            },
            fetchPolicy: "no-cache",
          });
          this.draft = response.data.borrador;
          this.bonoAplicable = response.data.borrador.pagado;
          if (this.draft.datos.datosConsulta) {
            this.datosDeudor.idLegal =
              this.draft.datos.datosConsulta.idLegalDeudor;
            this.datosCliente.tipo = this.draft.datos.datosConsulta
              .representacionPropia
              ? this.tipoSolicitud.propia
              : this.tipoSolicitud.terceros;
            this.datosCliente.idLegal = !this.draft.datos.datosConsulta
              .representacionPropia
              ? this.draft.datos.datosConsulta.idLegalRepresentado
              : "";
            this.datosCliente.nombre = !this.draft.datos.datosConsulta
              .representacionPropia
              ? this.draft.datos.datosConsulta.razonSocialRepresentado
              : "";
            this.opcion = this.draft.datos.datosConsulta.justificacion;
          }

          if (this.draft.referenciaPago && !this.draft.pagado) {
            const wlResponse = await this.$apollo.mutate({
              mutation: UPDATE_TRANSACTION_STATUS,
              variables: {
                operationId: this.draft.referenciaPago,
              },
            });

            this.draft.pagado =
              (
                wlResponse.data.updateTransactionStatus.datos || ""
              ).toUpperCase() === "SUCCESSFUL";
          }
        } catch (error) {
          console.error(error);
        }
      }
    },
    loadUserData() {
      this.$apollo
        .query({
          query: GET_USUARIO_BY_UUID,
          variables: {
            uuidUsuario: this.$store.state.profile.uuid,
            idioma: this.$i18n.locale,
          },
          fetchPolicy: "no-cache",
        })
        .then(({ data }) => {
          this.usuarioActual = data.getUsuarioUuid;
          if (
            this.$store.state.codigoPromotor != this.promotorEinforma &&
            ((data.getUsuarioUuid.genero !== "company" &&
              !data.getUsuarioUuid.apellidos) ||
              !data.getUsuarioUuid.nombre ||
              !data.getUsuarioUuid.idLegal ||
              !validations.validateNif(data.getUsuarioUuid.idLegal) ||
              !data.getUsuarioUuid.cliente.contactosActivos ||
              !data.getUsuarioUuid.cliente.contactosActivos.direccion ||
              !data.getUsuarioUuid.cliente.contactosActivos.direccion.valor ||
              !data.getUsuarioUuid.cliente.contactosActivos.direccion.valor
                .tipoDireccion ||
              !data.getUsuarioUuid.cliente.contactosActivos.direccion.valor
                .direccion ||
              !data.getUsuarioUuid.cliente.contactosActivos.direccion.valor
                .localidad ||
              !data.getUsuarioUuid.cliente.contactosActivos.direccion.valor
                .provincia ||
              !data.getUsuarioUuid.cliente.contactosActivos.direccion.valor
                .pais ||
              !data.getUsuarioUuid.cliente.contactosActivos.direccion.valor
                .codigoPostal)
          ) {
            this.displayModalFaltaInformacion = true;
          } else if (data.getUsuarioUuid.clienteIdLegal) {
            this.checkBonoAplicables(data.getUsuarioUuid.clienteIdLegal);
          }
        })
        .catch((error) => {
          this.errors.push(
            this.$i18n.t("consultaFichero.errores." + error.message)
          );
        });
    },
    async onSelectActuoEnPropioNombre() {
      try {
        const response = await this.$apollo.query({
          query: GET_USUARIO_BY_UUID,
          variables: {
            uuidUsuario: this.$store.state.profile.uuid,
            idioma: this.$i18n.locale,
          },
        });

        this.datosCliente.idLegal = response.data.getUsuarioUuid.idLegal;
        this.datosCliente.nombre = response.data.getUsuarioUuid.nombre
          ? response.data.getUsuarioUuid.nombre
          : response.data.getUsuarioUuid.razonSocial;
      } catch (error) {
        this.errors.push(
          this.$i18n.t("consultaFichero.errores." + error.message)
        );
      }
    },
    downloadPDF() {
      this.downloadFromUri(
        "Anexo_I_ICIRED.docx",
        window.location.origin + "/assets/documentos/Anexo_I_ICIRED.docx"
      );
    },
    redirigirAlProfile() {
      this.goToProfile();
    },
    checkBonoAplicables(idLegal) {
      if (this.success.length === 0 && !this.bonoAplicable) {
        this.$apollo
          .query({
            query: GET_PRODUCTOS_BY_IDLEGAL_CLIENTE,
            variables: {
              id: idLegal,
              idioma: this.$i18n.locale,
            },
            fetchPolicy: "no-cache",
          })
          .then((data) => {
            if (this.$route.params.codType) {
              const producto = data.data.productos.find(
                (prod) =>
                  prod.codigoProducto === this.$route.params.codType &&
                  prod.contrato.tipo === "BUSQUEDA_FICHERO_MOROSIDAD"
              );

              this.comprobarBonoProducto(producto);
            }
          })
          .catch((e) => {
            throw Error(e);
          });
      }
    },
    onProductoClick(producto) {
      this.selectedProducto = producto;
      this.comprobarBonoProducto(producto);
    },
    comprobarBonoProducto(producto) {
      this.success = [];

      if (producto && producto.promociones && producto.promociones.length > 0) {
        const bono = producto.promociones.find(
          (b) => b.literalTipoPromocion.clave === "BONO"
        );

        if (bono) {
          const usosRestantes = bono.numeroUsos - bono.contadorUsos;

          if (usosRestantes > 0) {
            this.success.push(
              this.$i18n.t("consultaFichero.textos.bonoAplicado1") +
                usosRestantes +
                this.$i18n.t("consultaFichero.textos.bonoAplicado2")
            );
            window.scrollTo(0, 0);
            return true;
          } else if(producto.contrato.excesos) {
            return true;
          }else if(usosRestantes <= 0 && !producto.contrato.excesos) {
            this.errors.push(
              this.$i18n.t("consultaFichero.textos.bonoAplicadoSinUsosNiExcesos")
            );
            window.scrollTo(0, 0);
            return false;
          }
        }
      }
    },
    validateForm() {
      let valid = true;
      this.errors = [];
      if (this.usuarioGrandesCuentas) {
        if (!this.datosDeudor.idLegal) {
          this.errors.push(
            this.$i18n.t("consultaFichero.messages.error.datosDeudor")
          );
          valid = false;
        }
        if (!this.usuarioCarteraSelected) {
          this.errors.push(
            this.$i18n.t("consultaFichero.messages.error.cartera")
          );
          valid = false;
        } else {
          if (!this.acreedorGrandesCuentas.nombre) {
            this.errors.push(
              this.$i18n.t(
                "consultaFichero.messages.error.nombreAcreedorORazonSocial"
              )
            );
            valid = false;
          }

          if (!this.acreedorGrandesCuentas.idLegal) {
            this.errors.push(
              this.$i18n.t("consultaFichero.messages.error.idLegalAcreedor")
            );
            valid = false;
          }
        }
        if (!this.selectedProducto) {
          this.errors.push(
            this.$i18n.t("consultaFichero.messages.error.producto")
          );
          valid = false;
        }
      } else {
        if (!this.datosCliente.tipo) {
          this.errors.push(
            this.$i18n.t("consultaFichero.messages.error.tipoCliente")
          );
          valid = false;
        } else if (
          this.datosCliente.tipo === this.tipoSolicitud.terceros &&
          !(this.datosCliente.nombre || this.datosCliente.idLegal)
        ) {
          this.errors.push(
            this.$i18n.t("consultaFichero.messages.error.datosCliente")
          );
          valid = false;
        }

        if (!this.datosDeudor.idLegal) {
          this.errors.push(
            this.$i18n.t("consultaFichero.messages.error.datosDeudor")
          );
          valid = false;
        }

        if (!this.opcion) {
          this.errors.push(
            this.$i18n.t("consultaFichero.messages.error.opcion")
          );
          valid = false;
        }

        if (
          this.draft &&
          this.draft.pagado &&
          this.datosDeudor.idLegal &&
          !validations.isValidCif(this.datosDeudor.idLegal) &&
          this.files.length < 2
        ) {
          this.errors.push(
            this.$i18n.t("consultaFichero.messages.error.documentacion")
          );
          valid = false;
        }
      }

      if (!valid) {
        window.scrollTo(0, 0);
      }

      return valid;
    },
    checkPreviousDrafts() {
      // Si se detectan borradores previos se lanza el aviso al usuario.
      if (!this.usuarioGrandesCuentas) {
        this.$apollo
          .query({
            query: QUERY_BORRADORES,
            variables: {
              criteria: {
                filter: [
                  `usuario.uuid~uuid=${this.$store.state.profile.uuid}`,
                  `plataforma~eq=${PLATAFORMA}`,
                  `tipo~eq=${TIPOS_SERVICIO.CONSULTA}`,
                ],
                page: 0,
                size: -1,
                sort: [],
              },
            },
            fetchPolicy: "no-cache",
          })
          .then((response) => {
            const drafts = response.data.listaBorradores;

            this.displayDraftWarningModal =
              drafts && drafts.totalElements > 0 && !this.$route.params.draftId;
          });
      }
    },
    setError(evt,error) {
      this.errors = []
      if(error) {
        this.errors.push(
          this.$i18n.t("consultaFichero.errores.23015")
        );
      }
    },
  },
  computed: {
    carteraUsuarioFilters() {
      return [
        `usuario.id~eq=${this.usuarioActual ? this.usuarioActual.id : 0}`,
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.resetMarginBot {
  margin-bottom: 0;
}

.resetMarginTop {
  margin-top: 0;
}

.p-field-radiobutton {
  margin: 15px 0px;
}

.whitePanel {
  padding: 1.5rem;
}

.bluePanel {
  color: white;
  background: linear-gradient(to right, #0388e5 0%, #07bdf4 100%);
  padding: 1.5rem;
}

.buttonContainer {
  display: flex;
  align-items: center;
  justify-content: center;

  .bigBlueButton {
    width: 10rem;
  }
}

.p-button-plain {
  border-color: white;
  background-color: transparent !important;

  &:hover {
    border-color: white !important;
    opacity: 0.5;
  }
}

.description-autorization {
  color: #2e9ece;
}
.marginNegative {
  margin-left: -6%;
}
.marginTop {
  margin-top: 2em;
}
</style>
